import { Outlet, useParams } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import RequireAuth from "./RequireAuth";

// Layout route of the /users/:id pages: the own profile is always open, the page of another user needs
// USERS `action` in the active winery. Put it inside the account type group (it checks no role itself).
const UserProfileGuard = ({ action = "read" }) => {
  const { id } = useParams();
  const { auth } = useAuth();

  const isOwn = id !== undefined && auth?.user_id !== undefined && String(auth.user_id) === String(id);
  if (isOwn) return <Outlet />;
  return <RequireAuth permission={["USERS", action]} />;
};

export default UserProfileGuard;
